import talk_1 from '@/assets/img/talk/talk_1.png'
import talk_2 from '@/assets/img/talk/talk_2.png'
import talk_3 from '@/assets/img/talk/talk_3.png'
import talk_4 from '@/assets/img/talk/talk_4.png'
import talk_5 from '@/assets/img/talk/talk_5.png'
import talk_6 from '@/assets/img/talk/talk_6.png'
import talk_7 from '@/assets/img/talk/talk_7.png'
import talk_8 from '@/assets/img/talk/talk_8.png'
import talk_9 from '@/assets/img/talk/talk_9.png'
import talk_10 from '@/assets/img/talk/talk_10.png'

export const TALK_MAIN = [{
  img: talk_1,
  text: 'Drag the mouse cursor around the map. <br /> Right-click on a blue box to move.'
}, {
  img: talk_2,
  text: 'Move next to the chest box.Left-click on the chest box to mine the treasure. '
}, {
  img: talk_4,
  text: 'Go back to home to submit gems and increase the leaderboard score. '
}, {
  img: talk_5,
  text: 'Left-click on any player, and you will see a panel.'
}, {
  img: talk_6,
  text: '“Move”: move to the player’s location. “Attack”: initiate a battle.'
}, {
  img: talk_7,
  text: '“Hunt”: lock on the target for automatic attacks. “Info”: check the user stats.'
}, {
  img: talk_8,
  text: 'When in a battle, select “Attack” to attack, or “Escape” to flee(might fail).'
}, {
  img: talk_9,
  text: 'Now select one of the strategies as a buff. Magic > Sneak > Sprint > Magic'
}, {
  img: talk_10,
  text: 'If your strategy counters the other’s, better chance of attacking/escaping.Vice versa.'
}]